import { PlayerNote } from '~/interfaces';
import { PlayerNumber } from '~/modules/players/player-number';

import styles from '../../styles';

export function getColor(
  _ctx: CanvasRenderingContext2D,
  playerNumber: PlayerNumber,
  isStar: boolean,
  isHit: boolean,
  isPerfect: boolean,
) {
  if (isPerfect && isStar) {
    return styles.colors.players[playerNumber].starPerfect;
  } else if (isPerfect) {
    return styles.colors.players[playerNumber].perfect;
  } else if (isStar && isHit) {
    return styles.colors.players[playerNumber].star;
  } else if (isHit) {
    return styles.colors.players[playerNumber].hit;
  } else {
    return styles.colors.players[playerNumber].miss;
  }
}

export default function getNoteColor(
  ctx: CanvasRenderingContext2D,
  playerNumber: PlayerNumber,
  isHit: boolean,
  playerNote: PlayerNote,
) {
  return getColor(ctx, playerNumber, playerNote.note.type === 'star', isHit, playerNote.isPerfect);
}
